// eslint-disable-next-line import/no-unresolved
import 'vite/modulepreload-polyfill';
import get from 'lodash.get';
import {
  initializeGA4,
  utagDirective,
  utagDirectiveName,
} from '@garmin/support-analytics';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { defaultConfig, plugin as formkit } from '@formkit/vue';
// eslint-disable-next-line no-unused-vars
import * as registerComponents from './modules/registerComponents.js';
import router from './router/router';
import App from './App.vue';
import TitleMixin from './mixins/pageTitle';

import('lazysizes');

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.mixin(TitleMixin);

app.config.globalProperties.$safeGet = get;
app.config.compilerOptions.whitespace = 'preserve';

app.use(formkit, defaultConfig({
  config: {
    classes: {
      messages: 'field-messages',
      message: 'field-message',
      outer: 'sc__form__field-group',
    },
  },
}));

utagDirective.inserted = utagDirective.mounted;
app.directive(utagDirectiveName, utagDirective);

initializeGA4();

app.mount('#app');
